import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import FormAsyncSelectField from '../../common/components/formFields/FormAsyncSelectField';
import { dataToSelect } from '../../common/helpers';
import { getDealersCities } from '../DealersActions';
import { SET_DEALERS_CITIES_SELECT_SEARCH_STATE } from '../DealersReducer';
import { capitalizeString } from '../../helpers/capitalizeString';

function DealerCitySelectField(props) {
  const dispatch = useDispatch();
  const [initialOptions, setInitialOptions] = useState([]);

  const fetchDealersCities = useCallback(
    (input = '', callback) => {
      dispatch(
        getDealersCities(input, (response) => {
          const options = dataToSelect(
            response.data.content.map((it) => ({ city: capitalizeString(it.city) })),
            ['city', 'city'],
          );
          dispatch({ type: SET_DEALERS_CITIES_SELECT_SEARCH_STATE, payload: options });
          callback?.(options);
          if (!input) setInitialOptions(options);
        }),
      );
    },
    [dispatch],
  );

  useEffect(() => {
    fetchDealersCities();
  }, [fetchDealersCities]);

  return (
    <FormAsyncSelectField
      {...props}
      loadOptions={_.debounce(fetchDealersCities, 500)}
      defaultOptions={initialOptions.length ? initialOptions : true}
    />
  );
}

export default DealerCitySelectField;
